module.exports = __webpack_public_path__ + "img/cd_phone.f42ae896.png";